import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/generators/buying-guides")({
  component: () => <ProductHubList hubSlug="generators" variant="buying-guides" />,
});
